/**
 * Custom element base class for login form.
 * Provides lifecycle hooks and utility methods for login form components.
 */
class LoginForm extends HTMLElement {
  constructor() {
    super();
    // Optionally attach a shadow root if needed in derived classes
    // this.attachShadow({ mode: 'open' });
  }

  /**
   * Called when the element is added to the DOM.
   * Override in subclasses for setup logic.
   */
  connectedCallback() {
    // To be implemented by subclasses
    // Pure JS: Handle forgot password and cancel actions for login form
    const forgotBtn = this.querySelector('.login-form__forgot-btn');
    const cancelBtn = this.querySelector('.recover-password-cancel__btn');
    const loginFormWrapper = this.querySelector('.login-form-wrapper');
    // The forgot password form container (may be named differently, so check both possible selectors)
    const forgotPasswordWrapper = this.querySelector('.login-form-forgot-password-wrapper');
    console.log('ee', forgotBtn, cancelBtn, loginFormWrapper, forgotPasswordWrapper);

    if (forgotBtn) {
      forgotBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (loginFormWrapper) loginFormWrapper.classList.add('hidden');
        if (forgotPasswordWrapper) forgotPasswordWrapper.classList.remove('hidden');
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (forgotPasswordWrapper) forgotPasswordWrapper.classList.add('hidden');
        if (loginFormWrapper) loginFormWrapper.classList.remove('hidden');
      });
    }
  }

  /**
   * Called when the element is removed from the DOM.
   * Override in subclasses for cleanup logic.
   */
  disconnectedCallback() {
    // To be implemented by subclasses
  }

  /**
   * Called when observed attributes change.
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    // To be implemented by subclasses
  }

  /**
   * Utility: Query selector within this element (shadow or light DOM).
   * @param {string} selector
   * @returns {Element|null}
   */
  $(selector) {
    return this.querySelector(selector);
  }

  /**
   * Utility: Query selector all within this element.
   * @param {string} selector
   * @returns {NodeListOf<Element>}
   */
  $all(selector) {
    return this.querySelectorAll(selector);
  }
}

// Register the custom element if not already defined
if (!customElements.get('login-form')) {
  customElements.define('login-form', LoginForm);
}


